import styled from 'styled-components';
import { ListboxGroupLabelMixin } from '../../mixins/components/ListboxGroupLabelMixin';
export var StyledListboxGroupLabel = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledListboxGroupLabel",
  componentId: "c11n-8-111-1__sc-75fvmb-0"
})(["", ""], ListboxGroupLabelMixin);